<template>
  <div class="a-menu">

    <div class="a-menu-login p-cta">
      <a class="l-rg" target="_blank" follow="nofollow" href="https://statestreet-icx.efrontcloud.com/StateStreet">Investor Login</a>
    </div>

    <div class="a-menu-trigger p-cta">
      <div class="a-menu-open">
        <!-- Menu -->
        <div class="a-menu-burger">
          <span class="raw-line"></span>
          <span class="raw-line"></span>
          <span class="raw-line"></span>
          <span class="hover-line"></span>
          <span class="hover-line"></span>
          <span class="hover-line"></span>
        </div>
      </div>
      <div class="a-menu-close">⤫</div>
    </div>

    <div class="a-menu-container">

      <div class="a-menu-items p-cta">
        <router-link class="a-menu-item" to="/about">
          <i class="a-menu-indicator"></i>
          <div class="a-menu-title">About</div>
        </router-link>

        <router-link class="a-menu-item" to="/people">
          <i class="a-menu-indicator"></i>
          <div class="a-menu-title">People</div>
        </router-link>

        <router-link class="a-menu-item" to="/careers">
          <i class="a-menu-indicator"></i>
          <div class="a-menu-title">Careers</div>
        </router-link>

        <router-link class="a-menu-item" to="/contact">
          <i class="a-menu-indicator"></i>
          <div class="a-menu-title">Contact</div>
        </router-link>
      </div>

      <div class="a-menu-images">
        <div class="a-menu-mask">
          <div class="a-menu-image">
            <img class="a-menu-src" src="~@/assets/images/header-about.jpg" alt="About">
          </div>
        </div>
        <div class="a-menu-mask">
          <div class="a-menu-image">
            <img class="a-menu-src" src="~@/assets/images/header-people.jpg" alt="People">
          </div>
        </div>
        <div class="a-menu-mask">
          <div class="a-menu-image">
            <img class="a-menu-src" src="~@/assets/images/header-careers.jpg" alt="Careers">
          </div>
        </div>
        <div class="a-menu-mask">
          <div class="a-menu-image">
            <img class="a-menu-src" src="~@/assets/images/header-contact.jpg" alt="Contact">
          </div>
        </div>
      </div>

      <div class="a-menu-bottom">
        <div class="a-menu-col">
          Copyright &copy; {{new Date().getFullYear()}} VR Capital Group Ltd. <span class="mobile-hidden">|</span>
          <router-link class="l-rg p-cta" to="/disclaimer/terms">Terms of Use and Disclaimers</router-link>
        </div>
        <div class="a-menu-col a-menu-col--investor">
          <a class="l-rg p-cta" target="_blank" follow="nofollow" href="https://statestreet-icx.efrontcloud.com/StateStreet">Investor Login</a>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import Menu from './menu';

export default {
  mounted() {
    const menu = new Menu();
    menu.init();
    this.handlerClose = () => menu.closeMenu();
    this.$root.$on('closeMenu', this.handlerClose);
  },

  beforeDestroy() {
    this.$root.$off('closeMenu', this.handlerClose);
  },
};
</script>
